<div class="contact-dialog-overlay" style="background-color: transparent;">
    <!-- Close button positioned outside the panel -->
    <div class="add-meeting-container">
        <!-- Header -->
        <div class="header">
            <h2>{{title}}</h2>
            <button [attr.guide]="'add-meeting-btn-1' + '__' + sanitizedUrl" mat-icon-button class="close-dialog-btn"
                (click)="dialogRef.close()">
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <div class="content" fxLayout="column" [formGroup]="firstFormGroup">

            <div class="result" fxLayout="column">
                <div class="container">
                    <div id="content">
                        <div>
                            <div>

                                <div class="padding-10" autocomplete="off">

                                    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">

                                        <mat-form-field appearance="outline" fxFlex>
                                            <mat-label>Title</mat-label>
                                            <input [attr.guide]="'add-meeting-inp-2' + '__' + sanitizedUrl"
                                                [readonly]="id > 0" [autocomplete]="'off'" trim="blur" required matInput
                                                formControlName="summary">
                                            <mat-error *ngIf="firstFormGroup.controls.summary.errors?.required">
                                                Please fill out this field.

                                            </mat-error>
                                        </mat-form-field>


                                    </div>


                                    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">

                                        <mat-form-field fxFlex appearance="outline" fxLayoutGap="10px">
                                            <mat-label>Start Date</mat-label>
                                            <input [attr.guide]="'add-meeting-inp-startdatetime' + '__' + sanitizedUrl"
                                                [min]="minDate" [matDatepicker]="startDateTime"
                                                formControlName="startDateTime" required matInput />
                                            <mat-datepicker-toggle [for]="startDateTime"
                                                matSuffix></mat-datepicker-toggle>
                                            <mat-datepicker #startDateTime></mat-datepicker>

                                            <mat-error *ngIf="firstFormGroup.controls.startDateTime.errors?.required">
                                                Please fill out this field.
                                            </mat-error>
                                        </mat-form-field>


                                        <mat-form-field fxFlex appearance="outline" fxLayoutGap="10px">
                                            <mat-label>Start Time</mat-label>
                                            <input [attr.guide]="'add-meeting-inp-starttime' + '__' + sanitizedUrl"
                                                type="time" formControlName="startTime" required matInput />

                                            <mat-error *ngIf="firstFormGroup.controls.startTime.errors?.required">
                                                Please fill out this field.
                                            </mat-error>

                                        </mat-form-field>


                                    </div>


                                    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">


                                        <div fxFlex="100" fxLayout="column" fxLayout.lt-md="column" fxLayoutGap="10px">
                                            <div fxFlex="100" fxLayout="row">
                                                <mat-form-field fxFlex="100" appearance="outline" fxLayoutGap="10px">
                                                    <mat-label>End Date</mat-label>
                                                    <input
                                                        [attr.guide]="'add-meeting-inp-enddatetime' + '__' + sanitizedUrl"
                                                        [min]="minDate" [matDatepicker]="endDateTime"
                                                        formControlName="endDateTime" required matInput />
                                                    <mat-datepicker-toggle [for]="endDateTime"
                                                        matSuffix></mat-datepicker-toggle>
                                                    <mat-datepicker #endDateTime></mat-datepicker>

                                                    <mat-error
                                                        *ngIf="firstFormGroup.controls.endDateTime.errors?.required">
                                                        Please fill out this field.
                                                    </mat-error>

                                                </mat-form-field>

                                            </div>

                                            <div>
                                                <span
                                                    *ngIf="firstFormGroup.errors?.dateTimeInvalid && (firstFormGroup.dirty || firstFormGroup.touched)"
                                                    style="color: #f44336; font-size: 12px; margin-top: -8px; margin-left: 14px;">
                                                    End date and time cannot be earlier than Start date and
                                                    time.
                                                </span>
                                            </div>

                                        </div>



                                        <mat-form-field fxFlex="50" appearance="outline" fxLayoutGap="10px">
                                            <mat-label>End Time</mat-label>
                                            <input [attr.guide]="'add-meeting-inp-endtime' + '__' + sanitizedUrl"
                                                type="time" formControlName="endTime" required matInput />

                                            <mat-error *ngIf="firstFormGroup.controls.endTime.errors?.required">
                                                Please fill out this field.
                                            </mat-error>

                                        </mat-form-field>


                                    </div>


                                    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">

                                        <mat-form-field appearance="outline" fxFlex>
                                            <mat-label>Zone</mat-label>
                                            <mat-select formControlName="timeZone">
                                                <mat-option *ngFor="let status of zone" [value]="status.value">
                                                    {{status.label}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" fxFlex>
                                            <mat-label>Status</mat-label>
                                            <mat-select formControlName="status">
                                                <mat-option *ngFor="let status of status" [value]="status.viewValue">
                                                    {{status.viewValue}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                    </div>



                                    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">

                                        <mat-form-field appearance="outline" fxFlex>
                                            <mat-label>Description</mat-label>
                                            <input [attr.guide]="'add-meeting-inp-description' + '__' + sanitizedUrl"
                                                [autocomplete]="'off'" trim="blur" required matInput
                                                formControlName="description" />
                                            <mat-error *ngIf="firstFormGroup.controls.description.errors?.required">
                                                Please fill out this field.

                                            </mat-error>
                                        </mat-form-field>


                                    </div>


                                    <div *ngIf="firstFormGroup.value.status == 'Completed'" fxLayout="row"
                                        fxLayout.lt-md="column" fxLayoutGap="10px">

                                        <mat-form-field appearance="outline" fxFlex>
                                            <mat-label>Meeting Summary</mat-label>
                                            <input [attr.guide]="'add-meeting-inp-meetingsummary' + '__' + sanitizedUrl"
                                                [autocomplete]="'off'" trim="blur" required matInput
                                                formControlName="meetingSummary" />
                                            <mat-error *ngIf="firstFormGroup.controls.meetingSummary.errors?.required">
                                                Please fill out this field.
                                            </mat-error>
                                        </mat-form-field>


                                    </div>

                                    <div fxLayout="row" *ngIf="id != 0" fxLayout.lt-md="column" fxLayoutGap="10px">

                                        <mat-form-field
                                            *ngIf="firstFormGroup.value.meetingDriveLink!=null && 
                                            firstFormGroup.value.meetingDriveLink !=undefined && firstFormGroup.value.meetingDriveLink != ''"
                                            appearance="outline" fxFlex="50">
                                            <mat-label>Drive Link</mat-label>
                                            <input
                                                [attr.guide]="'add-meeting-inp-meetingdrivelink' + '__' + sanitizedUrl"
                                                readonly [autocomplete]="'off'" trim="blur" matInput
                                                formControlName="meetingDriveLink" />

                                        </mat-form-field>

                                        <div fxFlex="100" fxLayoutAlign="space-around center"
                                            *ngIf="firstFormGroup.value.meetingDriveLink!=null && this.firstFormGroup.value.meetingDriveLink !=undefined && this.firstFormGroup.value.meetingDriveLink != ''">

                                            <button [attr.guide]="'add-meeting-btn-3' + '__' + sanitizedUrl"
                                                (click)="copyToClipboard(firstFormGroup.value.meetingDriveLink)">
                                                <mat-icon>content_copy</mat-icon>
                                            </button>


                                            <button [attr.guide]="'add-meeting-btn-4' + '__' + sanitizedUrl"
                                                mat-raised-button
                                                (click)="navigationTo(firstFormGroup.value.meetingDriveLink)">
                                                Open Link
                                            </button>

                                        </div>



                                    </div>


                                    <div *ngIf="data.type == 1" fxLayout="row" fxLayout.lt-md="column"
                                        fxLayoutGap="10px">

                                        <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Related to</mat-label>
                                            <mat-chip-list #chipList>
                                                <mat-chip *ngFor="let item of selectedLeads" [removable]="true"
                                                    (removed)="removeLead(item)">
                                                    {{item.name}}
                                                    <mat-icon matChipRemove>cancel</mat-icon>
                                                </mat-chip>
                                                <input [attr.guide]="'add-meeting-inp-5' + '__' + sanitizedUrl"
                                                    #leadInput placeholder="Click to select records"
                                                    [matAutocomplete]="auto1" [formControl]="leadCtrl"
                                                    [matChipInputFor]="chipList"
                                                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                                    (input)="onInputPaitent($event , 1)" />
                                            </mat-chip-list>

                                            <mat-autocomplete #auto1="matAutocomplete"
                                                (optionSelected)="onLeadSelected($event.option.value)">
                                                <mat-option *ngFor="let option of leadList" [value]="option">
                                                    {{option.name}}
                                                </mat-option>
                                            </mat-autocomplete>
                                        </mat-form-field>


                                    </div>

                                    <div *ngIf="data.type == 2" fxLayout="row" fxLayout.lt-md="column"
                                        fxLayoutGap="10px">

                                        <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Related to</mat-label>
                                            <mat-chip-list #chipList>
                                                <mat-chip *ngFor="let item of selectedLeads" [removable]="true"
                                                    (removed)="removeLead(item)">
                                                    {{item.name}}
                                                    <mat-icon matChipRemove>cancel</mat-icon>
                                                </mat-chip>
                                                <input [attr.guide]="'add-meeting-inp-6' + '__' + sanitizedUrl"
                                                    #leadInput placeholder="Click to select records"
                                                    [matAutocomplete]="auto1" [formControl]="leadCtrl"
                                                    [matChipInputFor]="chipList"
                                                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                                    (input)="onInputPaitent($event , 2)" />
                                            </mat-chip-list>

                                            <mat-autocomplete #auto1="matAutocomplete"
                                                (optionSelected)="onLeadSelected($event.option.value)">
                                                <mat-option *ngFor="let option of companyList" [value]="option">
                                                    {{option.name}}
                                                </mat-option>
                                            </mat-autocomplete>
                                        </mat-form-field>


                                    </div>

                                    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">


                                        <mat-form-field fxFlex appearance="outline">
                                            <mat-label>Attendees</mat-label>
                                            <mat-chip-list #attendeeChipList>
                                                <mat-chip *ngFor="let attendee of selectedAttendees" [removable]="true"
                                                    (removed)="removeAttendee(attendee)">
                                                    {{attendee.email}}
                                                    <mat-icon matChipRemove>cancel</mat-icon>
                                                </mat-chip>
                                                <input [attr.guide]="'add-meeting-inp-7' + '__' + sanitizedUrl"
                                                    #attendeeInput placeholder="Type to Search or Enter Email"
                                                    [matAutocomplete]="autoAttendee" [formControl]="attendeeCtrl"
                                                    [matChipInputFor]="attendeeChipList"
                                                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                                    (input)="onInputPaitent($event , 1)"
                                                    (keydown.enter)="addNewAttendee($event)" />
                                            </mat-chip-list>

                                            <mat-autocomplete #autoAttendee="matAutocomplete"
                                                (optionSelected)="onAttendeeSelected($event.option.value,attendeeCtrl.value)">
                                                <mat-option *ngFor="let option of leadList" [value]="option">
                                                    {{option.name}} ({{option.email}})
                                                </mat-option>
                                                <mat-option *ngIf="showAddNewOption" [value]="attendeeCtrl.value">
                                                    <mat-icon>add</mat-icon> Add "{{attendeeCtrl.value}}" as new
                                                    attendee
                                                </mat-option>
                                            </mat-autocomplete>
                                        </mat-form-field>



                                    </div>


                                    <div fxLayout="row" *ngIf="editMeeetingLink==1" fxLayout.lt-md="column"
                                        fxLayoutGap="10px">
                                        <mat-form-field appearance="outline" fxFlex>
                                            <mat-label>Meeting Link</mat-label>
                                            <input [attr.guide]="'add-meeting-inp-meetlink' + '__' + sanitizedUrl"
                                                [autocomplete]="'off'" trim="blur" required matInput
                                                formControlName="meetLink" />

                                        </mat-form-field>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



        </div>

        <div class="footer-actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
            <div *ngIf="id != 0">
                <button [attr.guide]="'add-meeting-btn-8' + '__' + sanitizedUrl" *ngIf="firstFormGroup.value.meetingDriveLink == '' 
               || firstFormGroup.value.meetingDriveLink == null 
               || firstFormGroup.value.meetingDriveLink == undefined" mat-raised-button (click)="generationLink()">
                    Generate Drive Link
                </button>
            </div>

            <button [attr.guide]="'add-meeting-btn-9' + '__' + sanitizedUrl" (click)="close()" mat-raised-button
                color="primary">
                Cancel

            </button>

            <button [attr.guide]="'add-meeting-btn-10' + '__' + sanitizedUrl" [disabled]="text != 'Save'"
                (click)="createCalenderEvent()" mat-raised-button color="primary">
                {{text}}
                <mat-icon *ngIf="text != 'Save'">
                    <mat-spinner color="primary" diameter="20"></mat-spinner>
                </mat-icon>
            </button>


        </div>


    </div>


</div>

<ng-template #dialogTemplate>
    <div class=" title"
        style=" padding: 16px; font-weight: bold; font-size: 18px; border-top-left-radius: 4px; border-top-right-radius: 4px;">
        Email
        <button [attr.guide]="'add-meeting-btn-11' + '__' + sanitizedUrl" mat-icon-button (click)="closeDialog()"
            style="float: right; color: white;">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- Dialog Body -->
    <div style="padding: 16px;">
        <form [formGroup]="attendeeForm">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">

                <mat-form-field fxFlex appearance="outline" fxLayoutGap="10px">
                    <mat-label>Email</mat-label>
                    <input [attr.guide]="'add-meeting-inp-email' + '__' + sanitizedUrl" formControlName="email" required
                        matInput />

                    <mat-error
                        *ngIf="attendeeForm.controls.email.hasError('required') && attendeeForm.controls.email.touched">
                        Please fill out this field.
                    </mat-error>
                    <mat-error
                        *ngIf="attendeeForm.controls.email.hasError('pattern') && attendeeForm.controls.email.touched">
                        Email format is Invalid.
                    </mat-error>



                </mat-form-field>
            </div>
        </form>

        <div fxLayout="row" fxLayoutAlign="end center" style="margin-top: 24px;">
            <button [attr.guide]="'add-meeting-btn-12' + '__' + sanitizedUrl" mat-stroked-button
                (click)="closeDialog()">Close</button>
            <button [attr.guide]="'add-meeting-btn-13' + '__' + sanitizedUrl" [disabled]="text !='Save'"
                (click)="createCalenderEvent()" mat-raised-button>
                {{text}}
                <mat-icon *ngIf="text !='Save' ">
                    <mat-spinner color="primary" diameter="20">
                    </mat-spinner>
                </mat-icon>
            </button>
        </div>
    </div>
</ng-template>